import { render, staticRenderFns } from "./TechDetails.vue?vue&type=template&id=4822f801&"
import script from "./TechDetails.vue?vue&type=script&lang=js&"
export * from "./TechDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports